import { call, takeEvery, put, select, delay } from 'redux-saga/effects';
import * as buttonsActions from '../../../../common/redux/actions/buttonsActions';
import { getProfileButtonsRequest } from '../../api/requests/getProfileButtonsRequest';
import { errorProcessing } from '../../../Employees/api/errorProcessing';
import { dataAdjustmentErrorResponse } from '../../../Employees/api/profileCard/dataAdjustment';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

// const getButtons = state => {
//   return (
//     state.Interface &&
//     state.Interface.buttons &&
//     state.Interface.buttons.buttons
//   );
// };

function* getButtonsSaga() {
  // let buttons = yield select(getButtons);
  // if (buttons && buttons.length === 0) {
    let activeProfileId = yield select(getActiveProfileId);
    if (activeProfileId) {
      try {
        const response = yield call(getProfileButtonsRequest, activeProfileId);
        yield put(buttonsActions.getProfileButtonsSuccess(response));
      } catch (e) {
        let errData = errorProcessing(e, dataAdjustmentErrorResponse);
        yield put(buttonsActions.getProfileButtonsFailure(errData));
      }
    } else {
      yield delay(1000);
      activeProfileId = yield select(getActiveProfileId);
      activeProfileId && (yield put(buttonsActions.getProfileButtons()));
    }
  // }
}

export function* buttonsWatcher() {
  yield takeEvery(buttonsActions.getProfileButtons.toString(), getButtonsSaga);
}
